export const estimatingSoftware = ["V6", "Logikal"];
